var _excluded = ["children", "title", "slidesToShow", "sliderRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import Slider from 'react-slick';
import useValueForCurrentViewPort from '../../../helpers/useValueForCurrentViewPort';
import './style.scss';
var SliderNextArrow = function SliderNextArrow(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "SliderRelated__next",
    onClick: onClick
  });
};
var SliderPrevArrow = function SliderPrevArrow(_ref2) {
  var onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "SliderRelated__prev",
    onClick: onClick
  });
};
var SliderRelated = function SliderRelated(props) {
  var children = props.children,
    title = props.title,
    slidesToShow = props.slidesToShow,
    sliderRef = props.sliderRef,
    sliderProps = _objectWithoutProperties(props, _excluded);
  var centerPadding = useValueForCurrentViewPort('10%', '10%', '10%', '10%', '10%');
  return /*#__PURE__*/React.createElement(Slider, _extends({}, sliderProps, {
    centerPadding: centerPadding,
    slidesToShow: slidesToShow,
    ref: sliderRef
  }), children);
};
SliderRelated.defaultProps = {
  title: null,
  slidesToShow: 3,
  infinite: true,
  centerMode: true,
  centerPadding: 0,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 7000,
  pauseOnFocus: true,
  accessibility: true,
  touchMove: true,
  nextArrow: /*#__PURE__*/React.createElement(SliderNextArrow, null),
  prevArrow: /*#__PURE__*/React.createElement(SliderPrevArrow, null),
  sliderRef: null
};
export default SliderRelated;